import { Pipe, PipeTransform } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

import { SafeHTML } from '@common/pipes';
import { Constants } from '@helper/constants';

@Pipe({ name: 'priceColorDisplay', standalone: true })
export class PriceColorDisplayPipe implements PipeTransform {
  constructor(private safeHtml: SafeHTML) {}

  transform(content: string): SafeHtml | undefined {
    const match = content.match(/\d+/);
    if (match?.index) {
      const start = match.index;
      const end = match.index + match[0].length;
      return this.safeHtml.transform(
        `${content.substring(0, start)}<span style="color: #555">${content.substring(
          start - 1,
          end
        )}</span>${content.substring(end)}`
      );
    }
    return undefined;
  }
}

@Pipe({ name: 'productInfoDisplay', standalone: true })
export class ProductInfoDisplayPipe implements PipeTransform {
  constructor(private safeHtml: SafeHTML) {}

  transform(value: string): SafeHtml {
    const infos = value.split(Constants.LINE_BREAK_PATTERN).filter(str => !!str);
    return this.safeHtml.transform(
      infos.map(info => `<div style="margin-left: 1.35em; text-indent: -1.35em">${info}</div>`).join('')
    );
  }
}
